import styled from "styled-components";
import { Colors } from "../../untils/Theme";

export const TabModalWrapper = styled.div`
  display:flex;
  width:100%;
  background-color:${Colors.white};
  position:sticky;
  top:0;
  z-index:1100;
  padding-bottom:1rem;

`
